import script from "./InspectionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionForm.vue?vue&type=script&setup=true&lang=js"

import "./InspectionForm.vue?vue&type=style&index=0&id=9bf45712&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bf45712"]])

export default __exports__